import React from 'react';
import { FaLightbulb } from 'react-icons/fa';
import styles from '../FeedbackPage.module.css'; // Adjust path if needed

const QuestionSection4 = ({
  activeSection,
  q4Improvement,
  handleImprovementChange,
  moveToPreviousSection,
  moveToNextSection,
  isLoading
}) => {
  return (
        <div 
        id="section-4" 
        className={`${styles.questionSection} ${activeSection === 4 ? styles.active : ''}`}
    >
        <div className={styles.questionIcon}>
            <FaLightbulb />
        </div>
        <label htmlFor="q4Improvement" className={styles.questionLabel}>
            4. What do you think should have been better in all 3 (Product Description, Title, Infographics)?
        </label>
        <textarea
            id="q4Improvement"
            className={styles.textarea}
            rows="4"
            placeholder="Your suggestions for improvement..."
            value={q4Improvement}
            onChange={handleImprovementChange}
            disabled={isLoading}
        />
        <div className={styles.navigationButtons}>
            <button 
                type="button" 
                className={`${styles.btn} ${styles.btnSecondary}`} 
                onClick={moveToPreviousSection}
            >
                Previous
            </button>
            <button 
                type="button" 
                className={`${styles.btn} ${styles.btnPrimary}`}
                onClick={moveToNextSection}
            >
                Next
            </button>
        </div>
    </div>
  );
};

export default QuestionSection4;
